import React from "react";
import type { ArticleProduct } from "@/domains/articles/ArticleProduct";
import { SPONSORED_LINK_REL } from "@/lib/LinkRel";

/**
 * 表の中などに置く商品の小さな写真。楽天の商品画像は商品ページへのリンクとして使う。
 */
export const ArticleProductThumbnail: React.FC<{ product: ArticleProduct }> = ({
  product,
}) => {
  const [rakutenLink] = product.links;
  return (
    <a
      href={rakutenLink.url}
      target="_blank"
      rel={SPONSORED_LINK_REL}
      className="relative mx-auto block h-16 w-16"
    >
      <img
        src={product.imageUrl}
        alt={product.name}
        loading="lazy"
        referrerPolicy="no-referrer"
        className="h-16 w-16 rounded-lg border border-primary-100 bg-white object-contain"
      />
      <span className="absolute left-0.5 top-0.5 rounded bg-white/90 px-1 text-[10px] leading-4 text-primary-500">
        PR
      </span>
    </a>
  );
};
